import { ContactsManager } from "components/contacts_manager/contacts_manager";
import { ArrowLeft } from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

export function ContactsManagement() {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={() => navigate("/admin/management")}>
          <ArrowLeft size={20} />
          Back to Management
        </button>
        <h1>Contacts Management</h1>
        <p>Manage contact information displayed to clients</p>
      </div>

      <div className={styles.content}>
        <ContactsManager />
      </div>
    </div>
  );
}
